// @ts-strict-ignore
import take from 'lodash/take';

import {Section, SectionItem} from 'common/components/items-menu/types';

import {COMPACT_TABLE_LEGEND_LINE_HEIGHT, MAX_SEGMENTS_PER_COMPACT_TABLE_ROW} from './constants';

export function getCardTableChartLegendHeight(legendSections: Section[]): number {
  if (legendSections.length === 0) {
    return 0;
  }

  const selectedSegmentsCount = legendSections.reduce(
    (accu, itemsObj) => accu + itemsObj.items.filter((item) => item.isSelected).length,
    0,
  );
  return Math.ceil(selectedSegmentsCount / MAX_SEGMENTS_PER_COMPACT_TABLE_ROW) * COMPACT_TABLE_LEGEND_LINE_HEIGHT;
}

export type ChartLegendItem = SectionItem & {
  /** items to show in the ChartLegend overflow menu (or tooltip if project does not have segment coloring) */
  tooltipSections?: SectionItem[];
};

export function rollUpExtraItemsIntoOther(items: SectionItem[], maxSections?: number): ChartLegendItem[] {
  // Only show a rolled up "Other" label if legend items are greater than max
  if (maxSections && items.length > maxSections) {
    // the - 1 is because we truncate 1 section in favor of the "Other" variable
    // (e.g. if we have 7 items and 6 max, then we need to only show the first 5 since the 6th will be the "other"
    // with the last two items
    const truncatedLegendSections = take(items, maxSections - 1);
    const hiddenSections = items.slice(maxSections - 1);

    truncatedLegendSections.push({
      label: `+${hiddenSections.length} More`,
      color: `var(--gray3)`,
      tooltipSections: hiddenSections,
    });

    items = truncatedLegendSections;
  }

  return items;
}
